import { useLang } from "../i18n/LangContext";
import { useSettings } from "../context/SettingsContext";
import { useSeo } from "../components/site/Seo";

const CONTENT = {
  privacy: {
    en: {
      title: "Privacy Policy",
      sections: [
        ["What we collect", "When you request service we collect your name, mobile phone number, optional email, your vehicle's location (and GPS coordinates only if you allow it), destination, vehicle details, notes and any photos you choose to upload."],
        ["How we use it", "We use this information only to respond to and complete your service request: to contact you, prepare a quote, dispatch help and keep a record of the job. We do not sell your information and we do not add you to marketing lists."],
        ["Calls and text messages", "By submitting a request you agree that we may call or text you about that request. Message and data rates may apply. You can ask us to stop at any time."],
        ["Who can see it", "Your request is visible only to authorized staff of {biz}. It is never shown publicly on this website. Service providers that deliver our email or text messages process the minimum information needed to send them."],
        ["Retention and deletion", "Completed and cancelled requests are kept for a limited period set by the business and then deleted. You can ask us to delete your request at any time by contacting us with your reference number."],
        ["Location permission", "Using your current location is optional. If you deny permission you can type the address instead."],
      ],
    },
    es: {
      title: "Política de Privacidad",
      sections: [
        ["Qué recopilamos", "Cuando solicita un servicio recopilamos su nombre, número de celular, correo opcional, la ubicación de su vehículo (y coordenadas GPS solo si lo permite), destino, datos del vehículo, notas y las fotos que decida subir."],
        ["Cómo lo usamos", "Usamos esta información solo para responder y completar su solicitud: contactarle, preparar una cotización, enviar ayuda y mantener un registro del trabajo. No vendemos su información ni le agregamos a listas de mercadeo."],
        ["Llamadas y mensajes de texto", "Al enviar una solicitud acepta que podamos llamarle o enviarle mensajes de texto sobre esa solicitud. Pueden aplicar tarifas de mensajes y datos. Puede pedirnos que paremos en cualquier momento."],
        ["Quién puede verla", "Su solicitud solo es visible para el personal autorizado de {biz}. Nunca se muestra públicamente en este sitio. Los proveedores que envían nuestros correos o mensajes procesan la información mínima necesaria."],
        ["Conservación y eliminación", "Las solicitudes completadas y canceladas se guardan por un periodo limitado definido por el negocio y luego se eliminan. Puede pedirnos eliminar su solicitud en cualquier momento contactándonos con su número de referencia."],
        ["Permiso de ubicación", "Usar su ubicación actual es opcional. Si niega el permiso puede escribir la dirección."],
      ],
    },
  },
  terms: {
    en: {
      title: "Terms of Service",
      sections: [
        ["Requests are not confirmed bookings", "Submitting a request online does not guarantee service. A request is confirmed only after {biz} contacts you and accepts the job."],
        ["Prices", "Any price shown is a guide. The final price is agreed with you before work begins."],
        ["Arrival times", "We do not promise an arrival time until a driver is dispatched and we tell you the estimate directly."],
        ["Emergencies", "This website is not an emergency service. If you are in danger or anyone is injured, call 911."],
        ["Accurate information", "Please provide accurate location and vehicle information so we can help you safely."],
      ],
    },
    es: {
      title: "Términos del Servicio",
      sections: [
        ["Las solicitudes no son reservas confirmadas", "Enviar una solicitud en línea no garantiza el servicio. Una solicitud se confirma solo después de que {biz} le contacta y acepta el trabajo."],
        ["Precios", "Cualquier precio mostrado es una referencia. El precio final se acuerda con usted antes de comenzar."],
        ["Tiempos de llegada", "No prometemos un tiempo de llegada hasta que un conductor sea despachado y le informemos el estimado directamente."],
        ["Emergencias", "Este sitio no es un servicio de emergencia. Si está en peligro o hay heridos, llame al 911."],
        ["Información correcta", "Por favor proporcione información correcta de ubicación y vehículo para poder ayudarle con seguridad."],
      ],
    },
  },
};

export default function LegalPage({ kind }) {
  const { lang } = useLang();
  const { settings } = useSettings();
  const c = CONTENT[kind][lang];
  useSeo(`${c.title} | ${settings.business_name}`, `${c.title} — ${settings.business_name}, Houston, Texas.`);
  return (
    <article className="container-x max-w-3xl py-16 sm:py-24" data-testid={`legal-page-${kind}`}>
      <h1 className="text-4xl sm:text-5xl font-extrabold uppercase">{c.title}</h1>
      {c.sections.map(([h, p]) => (
        <section key={h} className="mt-10">
          <h2 className="text-xl font-bold uppercase text-[#FACC15]">{h}</h2>
          <p className="mt-3 leading-relaxed text-gray-300">{p.replaceAll("{biz}", settings.business_name)}</p>
        </section>
      ))}
    </article>
  );
}
